import { graphql } from '@/generated/gql';

export const LOAD_APP_CONFIG_QUERY = graphql(/* GraphQL */ `
  query LoadAppConfig {
    appConfig(limit: 1) {
      id
      userId
      navDrawerPinned
    }
  }
`);
